module.exports = __webpack_public_path__ + "assets/img/mask-pop-bg.014a94a6.png";